import type { PiralPlugin } from 'piral-core'
import { fetchListPage } from './client'
import { setMembership, useListIds, useListMembership } from './store'
import type { ListName, ListPageOptions, PiletListsApi } from './types'

export type {
  ListIdsState,
  ListItem,
  ListManifest,
  ListMembership,
  ListName,
  ListPage,
  ListPageInfo,
  ListPageOptions,
  PiletListsApi,
} from './types'

/**
 * Piral plugin that puts the saved lists on every pilet's API.
 *
 * Same ownership rule as telemetry, analytics and the domain configuration: the shell
 * holds the state and hands out functions. A pilet cannot reach the manifest store,
 * cannot fetch its own copy, and therefore cannot disagree with the pilet next to it
 * about whether a title is saved — which is the entire point of moving these lists
 * off localStorage and onto the account.
 */
export function createListsApi (): PiralPlugin<PiletListsApi> {
  return () => ({
    getList (list: ListName, options?: ListPageOptions) {
      return fetchListPage(list, options)
    },
    addToList (list: ListName, movieId: string) {
      return setMembership(list, movieId, true)
    },
    removeFromList (list: ListName, movieId: string) {
      return setMembership(list, movieId, false)
    },
    useListMembership,
    useListIds,
  })
}
